import { createI18n } from 'vue-i18n'
import zh from './zh'
import en from './en'
import ja from './ja'
import ko from './ko'
import zhTW from './zh-TW'

function getDefaultLang() {
  const saved = localStorage.getItem('lang')
  if (saved) return saved
  const browserLang = navigator.language || navigator.userLanguage
  if (browserLang.startsWith('zh')) {
    if (browserLang === 'zh-TW' || browserLang === 'zh-Hant') return 'zh-TW'
    return 'zh'
  }
  if (browserLang.startsWith('ja')) return 'ja'
  if (browserLang.startsWith('ko')) return 'ko'
  return 'en'
}

const i18n = createI18n({
  legacy: false,
  locale: getDefaultLang(),
  fallbackLocale: 'en',
  messages: { zh, en, ja, ko, 'zh-TW': zhTW }
})

export function localPath(path) {
  const lang = i18n.global.locale.value
  if (path === '/') return `/${lang}`
  if (path.startsWith('/')) {
    return `/${lang}${path}`
  }
  return `/${lang}/${path}`
}

export default i18n
